import { SvgIconProps } from "../types";

export const SvgIcon = ({ src, width, height, fetchPriority }: SvgIconProps) => (
  <img src={`/img/svg/${src}`} alt={src} width={width} height={height} {...(fetchPriority ? { fetchpriority: fetchPriority } : {})}  />
);
